import { request as requester } from 'sonata-react-components';
import { CsvConfig } from 'sonata-static-storage/lib/common/common.types';

import type { Token } from './common.types';

export type DataProcessResultError = {
  column: number;
  critical?: boolean;
  row: number;
  type: string;
};

export type DataProcessResult = {
  dataPreview: string[][];
  dataTypes: string[];
  errors: DataProcessResultError[];
  exceedsMaxRows?: boolean;
  headers: string[];
  maxRows?: number;
  status: 'loading' | 'success' | 'idle' | 'error';
  s3Path?: string;
  totalLines?: number;
} & ({ status: 'success'; s3Path: string } | { status: Exclude<'loading' | 'success' | 'idle' | 'error', 'success'> });

export function postBatchExportVenues(
  userId: string,
  venueIds: string[],
  fileType: 'csv' | 'excel',
  token: Token
): Promise<string> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}batch/export/venues/${userId}`, {
    data: JSON.stringify({
      fileType,
      userId,
      venues: venueIds
    }),
    dataType: 'text',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    token
  });
}

export function preprocessCsvFile({
  columnMapping,
  columns = [],
  delimiter,
  file,
  numberOfLines,
  numericSeparator,
  rowLimitKey
}: {
  columnMapping?: CsvConfig['columnMapping'];
  columns?: string[];
  file: File;
  delimiter: string;
  numberOfLines: number;
  numericSeparator: string;
  rowLimitKey?: string;
}): Promise<DataProcessResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', file.name);
  formData.append('delimiter', delimiter);
  formData.append('numericSeparator', numericSeparator);
  formData.append('numberOfLines', numberOfLines.toString());
  if (columnMapping) {
    formData.append('columnMapping', JSON.stringify(columnMapping));
  }

  if (columns.length) {
    formData.append('columns', columns.join(','));
  }

  if (rowLimitKey) {
    formData.append('rowLimitKey', rowLimitKey);
  }

  return requester.makeRequest(`${taptap.config.backendUrlBase}filesReader/preprocess`, {
    data: formData,
    method: 'POST'
  });
}
